<app-loader *ngIf="isDisabled || isPageDisabled"></app-loader>
<div class="card">
    <form name="AttendancePoliciesForm" (ngSubmit)="Validate(AttendancePoliciesForm)" #AttendancePoliciesForm="ngForm"
        novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Attendance Policy
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-3">
                        <div class="col-md-2 align-self-center">
                            <label for="AttendanceRuleName" class="form-label text-label-dark">Policy Name :</label>
                        </div>
                        <div class="col-md-5">
                            <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                id="AttendanceRuleName" name="AttendanceRuleName"
                                [(ngModel)]="AttendanceRuleDetail.AttendanceRuleName" #AttendanceRuleName="ngModel"
                                maxlength="100" required>
                            <div class="invalid-feedback">
                                Please Enter Policy Name!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label for="WebCheckInOut" class="form-label text-label-dark">Check In/Out :</label>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="WebCheckInOut"
                                            name="WebCheckInOut" [(ngModel)]="AttendanceRuleDetail.WebCheckInOut">
                                        <label class="form-check-label text-label-light" for="WebCheckInOut">Web Check
                                            In/Out</label>
                                        <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                            [ngbTooltip]="tooltip.AttendancePolicy.WebCheckInOut"></i>
                                    </div>
                                </div>

                                <div class="col-md-12 ps-5 mb-2">
                                    <div class="row">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="RestrictIP"
                                                name="RestrictIP" [(ngModel)]="AttendanceRuleDetail.RestrictIP"
                                                [disabled]="!AttendanceRuleDetail.WebCheckInOut">
                                            <label class="form-check-label text-label-light" for="RestrictIP">Restrict
                                                IP</label>
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.AttendancePolicy.RestrictIP"></i>

                                            <input type="text" maxlength="39" class="form-control text-label-light"
                                                style="width: 200px;" placeholder="Ex. XXX.XXX.XXX.XXX" id="IPAddress"
                                                name="IPAddress"
                                                [disabled]="!AttendanceRuleDetail.RestrictIP || !AttendanceRuleDetail.WebCheckInOut"
                                                [(ngModel)]="AttendanceRuleDetail.IP" #IPAddress="ngModel"
                                                [required]="AttendanceRuleDetail.RestrictIP">
                                            <div class="invalid-feedback">
                                                Please enter ip address!
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="MobileCheckInOut"
                                            name="MobileCheckInOut" [(ngModel)]="AttendanceRuleDetail.MobileCheckInOut">
                                        <label class="form-check-label text-label-light" for="MobileCheckInOut">Mobile
                                            Check
                                            In/Out</label>
                                        <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                            [ngbTooltip]="tooltip.AttendancePolicy.MobilecheckInOut"></i>
                                    </div>
                                </div>
                                <div class="col-md-12 ps-5">
                                    <div class="row">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="GeoTagging"
                                                name="GeoTagging" [(ngModel)]="AttendanceRuleDetail.GeoTagging"
                                                [disabled]="!AttendanceRuleDetail.MobileCheckInOut">
                                            <label class="form-check-label text-label-light" for="GeoTagging">Geo
                                                Tagging</label>
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.AttendancePolicy.GeoTagging"></i>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 p-0">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="SiteQRCodeScanning"
                                                    name="SiteQRCodeScanning"
                                                    [(ngModel)]="AttendanceRuleDetail.SiteQRCodeScanning"
                                                    [disabled]="!AttendanceRuleDetail.MobileCheckInOut">
                                                <label class="form-check-label text-label-light"
                                                    for="SiteQRCodeScanning">Site QR Code
                                                    Scanning</label>
                                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                    [ngbTooltip]="tooltip.AttendancePolicy.SiteQRCodeScanning"></i>
                                            </div>
                                        </div>
                                        <div class="col-12 ps-5">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="SiteQRMandatory"
                                                    name="SiteQRMandatory"
                                                    [(ngModel)]="AttendanceRuleDetail.SiteQRMandatory"
                                                    [disabled]="!AttendanceRuleDetail.MobileCheckInOut || !AttendanceRuleDetail.SiteQRCodeScanning">
                                                <label class="form-check-label text-label-light"
                                                    for="SiteQRMandatory">Mandatory</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 p-0">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    id="EmployeeQRCodeScanning" name="EmployeeQRCodeScanning"
                                                    [(ngModel)]="AttendanceRuleDetail.EmployeeQRCodeScanning"
                                                    [disabled]="!AttendanceRuleDetail.MobileCheckInOut">
                                                <label class="form-check-label text-label-light"
                                                    for="EmployeeQRCodeScanning">Employee QR Code
                                                    Scanning</label>
                                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                    [ngbTooltip]="tooltip.AttendancePolicy.EmployeeQRCodeScanning"></i>
                                            </div>
                                        </div>
                                        <div class="col-12 ps-5">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="EmployeeQRMandatory"
                                                    name="EmployeeQRMandatory"
                                                    [(ngModel)]="AttendanceRuleDetail.EmployeeQRMandatory"
                                                    [disabled]="!AttendanceRuleDetail.MobileCheckInOut || !AttendanceRuleDetail.EmployeeQRCodeScanning">
                                                <label class="form-check-label text-label-light"
                                                    for="EmployeeQRMandatory">Mandatory</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="RestrictIMEI"
                                                name="RestrictIMEI" [(ngModel)]="AttendanceRuleDetail.Restrict_IMEI"
                                                [disabled]="!AttendanceRuleDetail.MobileCheckInOut">
                                            <label class="form-check-label text-label-light" for="RestrictIMEI">Restrict
                                                IMEI No</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 p-0">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="Selfie"
                                                    name="Selfie" [(ngModel)]="AttendanceRuleDetail.Selfie"
                                                    [disabled]="!AttendanceRuleDetail.MobileCheckInOut">
                                                <label class="form-check-label text-label-light"
                                                    for="Selfie">Selfie</label>
                                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                    [ngbTooltip]="tooltip.AttendancePolicy.Selfie"></i>
                                            </div>
                                        </div>
                                        <div class="col-12 ps-5">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="SelfieType"
                                                    name="SelfieType" [(ngModel)]="AttendanceRuleDetail.SelfieType"
                                                    [disabled]="!AttendanceRuleDetail.MobileCheckInOut || !AttendanceRuleDetail.Selfie">
                                                <label class="form-check-label text-label-light"
                                                    for="SelfieType">Mandatory</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-md-12">
                                            <div class="row ps-5">
                                                <div class="btn-group btn-group-toggle">
                                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                                        <input class="form-check-input" type="radio" value="Compulsory"
                                                            name="RDSelfie"
                                                            [(ngModel)]="AttendanceRuleDetail.SelfieType"
                                                            [disabled]="!AttendanceRuleDetail.MobileCheckInOut || !AttendanceRuleDetail.Selfie"
                                                            [ngModelOptions]="{standalone: true}">
                                                        Compulsory
                                                    </label>
                                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                                        <input class="form-check-input" type="radio"
                                                            value="Non Compulsory" name="RDSelfie"
                                                            [(ngModel)]="AttendanceRuleDetail.SelfieType"
                                                            [disabled]="!AttendanceRuleDetail.MobileCheckInOut || !AttendanceRuleDetail.Selfie"
                                                            [ngModelOptions]="{standalone: true}">
                                                        Non Compulsory
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsSiteManpowerLimit"
                                            name="IsSiteManpowerLimit"
                                            [(ngModel)]="AttendanceRuleDetail.IsSiteManpowerLimit">
                                        <label class="form-check-label text-label-light" for="IsSiteManpowerLimit">Site
                                            Manpower Limit</label>
                                        <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label for="WebCheckInOut" class="form-label text-label-dark">Mobile App Feature/Visibility
                                :</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.AttendancePolicy.MobileAppfeaturevisibility"></i>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="PaySlip" name="PaySlip"
                                            [(ngModel)]="AttendanceRuleDetail.PaySlip">
                                        <label class="form-check-label text-label-light" for="PaySlip">Payslip</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="Leave" name="Leave"
                                            [(ngModel)]="AttendanceRuleDetail.Leave">
                                        <label class="form-check-label text-label-light" for="Leave">Leave</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="Regularization"
                                            name="Regularization" [(ngModel)]="AttendanceRuleDetail.Regularization">
                                        <label class="form-check-label text-label-light"
                                            for="Regularization">Regularization</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="AttendanceSummary"
                                            name="AttendanceSummary"
                                            [(ngModel)]="AttendanceRuleDetail.AttendanceSummary">
                                        <label class="form-check-label text-label-light"
                                            for="AttendanceSummary">Attendance Summary</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="Menu" name="Menu"
                                            [(ngModel)]="AttendanceRuleDetail.Menu">
                                        <label class="form-check-label text-label-light" for="Menu">Menu</label>
                                    </div>
                                </div>
                                <div class="col-md-12 ps-5">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsLetterApproval"
                                            name="IsLetterApproval" [(ngModel)]="AttendanceRuleDetail.IsLetterApproval"
                                            [disabled]="!AttendanceRuleDetail.Menu">
                                        <label class="form-check-label text-label-light" for="IsLetterApproval">Letter
                                            Approval</label>
                                    </div>
                                </div>
                                <div class="col-md-12 ps-5">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsTaxDeclaration"
                                            name="IsTaxDeclaration" [(ngModel)]="AttendanceRuleDetail.IsTaxDeclaration"
                                            [disabled]="!AttendanceRuleDetail.Menu">
                                        <label class="form-check-label text-label-light"
                                            for="IsTaxDeclaration">TaxDeclaration</label>
                                    </div>
                                </div>
                                <div class="col-md-12 ps-5">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsTaxDetails"
                                            name="IsTaxDetails" [(ngModel)]="AttendanceRuleDetail.IsTaxDetails"
                                            [disabled]="!AttendanceRuleDetail.Menu">
                                        <label class="form-check-label text-label-light"
                                            for="IsTaxDetails">TaxDetails</label>
                                    </div>
                                </div>
                                <div class="col-md-12 ps-5">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsExpense" name="IsExpense"
                                            [(ngModel)]="AttendanceRuleDetail.IsExpense"
                                            [disabled]="!AttendanceRuleDetail.Menu">
                                        <label class="form-check-label text-label-light" for="IsExpense">Expense</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="OtherDuty" name="OtherDuty"
                                            [(ngModel)]="AttendanceRuleDetail.OtherDuty"
                                            [disabled]="common.ToLowerCase(AttendanceRuleDetail.EmpType) == 'back'">
                                        <label class="form-check-label text-label-light" for="OtherDuty">Other
                                            Duty</label>
                                    </div>
                                </div>
                                <div class="col-md-12 ps-5">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsOtherDutySelf"
                                            name="IsOtherDutySelf" [(ngModel)]="AttendanceRuleDetail.IsOtherDutySelf"
                                            [disabled]="!AttendanceRuleDetail.OtherDuty || common.ToLowerCase(AttendanceRuleDetail.EmpType) == 'back'">
                                        <label class="form-check-label text-label-light" for="IsOtherDutySelf">Other
                                            Duty Self</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="AllowAttendanceOnAnySite"
                                            name="AllowAttendanceOnAnySite"
                                            [(ngModel)]="AttendanceRuleDetail.AllowAttendanceOnAnySite">
                                        <label class="form-check-label text-label-light"
                                            for="AllowAttendanceOnAnySite">Allow Attendance On Any Site</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="ReportingPerson"
                                            name="ReportingPerson" [(ngModel)]="AttendanceRuleDetail.ReportingPerson">
                                        <label class="form-check-label text-label-light" for="ReportingPerson">Reporting
                                            Person</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="BranchContact"
                                            name="BranchContact" [(ngModel)]="AttendanceRuleDetail.BranchContact">
                                        <label class="form-check-label text-label-light" for="BranchContact">Branch
                                            Contact</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="CompanyContact"
                                            name="CompanyContact" [(ngModel)]="AttendanceRuleDetail.CompanyContact">
                                        <label class="form-check-label text-label-light" for="CompanyContact">Company
                                            Contact</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsHelpDesk"
                                            name="ISHelpDesk" [(ngModel)]="AttendanceRuleDetail.IsHelpDesk">
                                        <label class="form-check-label text-label-light"
                                            for="IsHelpDesk">HelpDesk</label>
                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsEmpProfile"
                                            name="ISEmpProfile" [(ngModel)]="AttendanceRuleDetail.IsEmpProfile">
                                        <label class="form-check-label text-label-light" for="IsEmpProfile">Profile
                                            Update</label>
                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsOutDoor" name="ISOutDoor"
                                            [(ngModel)]="AttendanceRuleDetail.IsOutDoor">
                                        <label class="form-check-label text-label-light" for="IsOutDoor">OutDoor</label>
                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsMyTeam" name="ISMyTeam"
                                            [(ngModel)]="AttendanceRuleDetail.IsMyTeam">
                                        <label class="form-check-label text-label-light" for="IsMyTeam">My Team</label>
                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsCompoff" name="IsCompOff"
                                            [(ngModel)]="AttendanceRuleDetail.IsCompOff">
                                        <label class="form-check-label text-label-light" for="IsCompOff">CompOff</label>
                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsCompoffConsume"
                                            name="IsCompOffConsume" [(ngModel)]="AttendanceRuleDetail.IsCompOffConsume">
                                        <label class="form-check-label text-label-light" for="IsCompOffConsume">CompOff
                                            Consume</label>
                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsoptionalHoliday"
                                            name="IsOptionalHoliday"
                                            [(ngModel)]="AttendanceRuleDetail.IsOptionalHoliday">
                                        <label class="form-check-label text-label-light"
                                            for="IsOptionalHoliday">Optional Holiday</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label for="SetApprovalFor" class="form-label text-label-dark">Set Approval For:</label>
                        </div>
                        <div class="col-md-10">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="IsOtherDuty" name="IsOtherDuty"
                                    [(ngModel)]="AttendanceRuleDetail.IsOtherDuty"
                                    [disabled]="common.ToLowerCase(AttendanceRuleDetail.EmpType) == 'back'">
                                <label class="form-check-label text-label-light" for="IsOtherDuty">Other Duty</label>
                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                    [ngbTooltip]="tooltip.AttendancePolicy.OtherDuty"></i>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="AllAttendance" name="AllAttendance"
                                    [(ngModel)]="AttendanceRuleDetail.IsAttendanceAll">
                                <label class="form-check-labe text-label-light" for="AllAttendance">All Attendance
                                </label>
                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                    [ngbTooltip]="tooltip.AttendancePolicy.AllAttendance"></i>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="GeoTaggingNotMapped"
                                    name="GeoTaggingNotMapped" [(ngModel)]="AttendanceRuleDetail.GeoTaggingNotMapped">
                                <label class="form-check-labe text-label-light" for="GeoTaggingNotMapped">Geo Tagging
                                    Not Mapped </label>
                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                    [ngbTooltip]="tooltip.AttendancePolicy.GeoTaggingNotmapped"></i>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="IsOnlineAttendance"
                                    name="IsOnlineAttendance" [(ngModel)]="AttendanceRuleDetail.IsOnlineAttendance">
                                <label class="form-check-labe text-label-light" for="GeoTaggingNotMapped">Web Attendance Approval</label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="IsAutoAttendanceApplicable"
                                    name="IsAutoAttendanceApplicable" [(ngModel)]="AttendanceRuleDetail.IsAutoAttendanceApplicable">
                                <label class="form-check-labe text-label-light" for="GeoTaggingNotMapped">Auto Attendance Applicable</label>
                            </div>

                            <!-- <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="AllAttendance" name="AllAttendance"
                                    [(ngModel)]="AttendanceRuleDetail.IsAttendanceAll">
                                <label class="form-check-labe text-label-light" for="AllAttendance">Geo Location Not Map </label>
                            </div> -->

                        </div>

                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label for="DefaultRule" class="form-label text-label-dark">Employee Type:</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.AttendanceRuleDetail.ESS_AttendanceRuleID == 0) || (this.AttendanceRuleDetail.ESS_AttendanceRuleID > 0 && common.ToLowerCase(AttendanceRuleDetail.EmpType) == 'front')">
                                    <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                        [(ngModel)]="AttendanceRuleDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                        (change)="GetApplicability()"
                                        [disabled]="AttendanceRuleDetail.ESS_AttendanceRuleID > 0" required>
                                    Front Office
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.AttendanceRuleDetail.ESS_AttendanceRuleID == 0) || (this.AttendanceRuleDetail.ESS_AttendanceRuleID > 0 && common.ToLowerCase(AttendanceRuleDetail.EmpType) == 'back')">
                                    <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                        [(ngModel)]="AttendanceRuleDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                        (change)="GetApplicability()"
                                        [disabled]="AttendanceRuleDetail.ESS_AttendanceRuleID > 0" required>
                                    Back Office
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label for="DefaultRule" class="form-label text-label-dark">Default Rule :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true name="DefaultRule"
                                        [(ngModel)]="AttendanceRuleDetail.DefaultAttendance"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false name="DefaultRule"
                                        [(ngModel)]="AttendanceRuleDetail.DefaultAttendance"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="AttendanceRuleDetail.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                                        [disabled]="Applicability.WebESSApplicabilityMasterID == 0 && AttendanceRuleDetail.DefaultAttendance">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label class="form-check-label" for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && AttendanceRuleDetail.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.WebESSApplicabilityId}}{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.WebESSApplicabilityId}}{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.WebESSApplicabilityId}}{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.AttendanceRuleDetail.ESS_AttendanceRuleID == 0) || (this.common.PageRight.IsEdit && this.AttendanceRuleDetail.ESS_AttendanceRuleID > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>